// extracted by mini-css-extract-plugin
export default {"subheader":"style_subheader__ZhrE1","errorContent":"style_errorContent__Ipbak"};